import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useState } from 'react';
import { shape, func, string, arrayOf, number, bool } from 'prop-types';
import { LuizaCard as LuizaCardIcon, CreditCard, BankSlip as BankSlipIcon, Pix as PixIcon } from '@magalu/stereo-ui-icons';
import { currencyFormatter } from '@magalu/stereo-ui-utils';
import PaymentMethodsTabs from './payment-methods-tab';
import { Title, Discount, Description, Amount, SlipContent } from './payment-methods.styles';
import { LuCardLabel, CreditCardLabel, BankSlipLabel, DiscountLabel, SlipDescription, PixLabel, PixDescription } from './payment-methods.data';
import Flex from '../../atoms/Flex';
import PaymentTable from './payment-table';
import { TabContext, TabPanel } from '../../atoms';

const getPaymentsById = payments => Object.values(payments).reduce((acc, item) => Object.assign({}, acc, {
  [item.id]: item
}), {});

const PaymentMethods = ({
  asTab,
  showMoreLabel,
  onChange,
  payments
}) => {
  var _pix$installmentPlans, _pix$installmentPlans2, _pix$installmentPlans3, _pix$installmentPlans4, _pix$installmentPlans5, _pix$installmentPlans6, _bankSlip$installment, _bankSlip$installment2, _bankSlip$installment3, _bankSlip$installment4, _bankSlip$installment5, _bankSlip$installment6;

  const {
    luizaCard,
    creditCard,
    bankSlip,
    pix
  } = payments;
  const [value, setValue] = useState((luizaCard == null ? void 0 : luizaCard.id) || (creditCard == null ? void 0 : creditCard.id) || (pix == null ? void 0 : pix.id) || (bankSlip == null ? void 0 : bankSlip.id) || '');
  const paymentById = getPaymentsById(payments);

  const handleChange = (e, paymentMethodId) => {
    setValue(paymentMethodId);
    onChange(paymentById[paymentMethodId]);
  };

  const Item = asTab ? TabPanel : Flex;
  const itemProps = asTab ? {
    width: '100%'
  } : {
    display: 'block',
    flex: '1 1'
  };
  return /*#__PURE__*/React.createElement(TabContext, {
    value: value
  }, asTab && /*#__PURE__*/React.createElement(PaymentMethodsTabs, {
    onChange: handleChange,
    payments: payments
  }), /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between",
    gap: 2,
    flexWrap: "wrap"
  }, (luizaCard == null ? void 0 : luizaCard.installmentPlans) && /*#__PURE__*/React.createElement(Item, _extends({}, itemProps, {
    "data-testid": "luizaCard-panel",
    value: luizaCard == null ? void 0 : luizaCard.id
  }), /*#__PURE__*/React.createElement(Title, null, !asTab && /*#__PURE__*/React.createElement(LuizaCardIcon, {
    mr: 2
  }), " ", LuCardLabel), /*#__PURE__*/React.createElement(PaymentTable, {
    luizaCard: luizaCard == null ? void 0 : luizaCard.installmentPlans,
    showAll: asTab,
    "data-testid": "luizaCard-table",
    showMoreLabel: showMoreLabel,
    installments: luizaCard.installmentPlans
  })), (creditCard == null ? void 0 : creditCard.installmentPlans) && /*#__PURE__*/React.createElement(Item, _extends({}, itemProps, {
    "data-testid": "creditCard-panel",
    value: creditCard == null ? void 0 : creditCard.id
  }), /*#__PURE__*/React.createElement(Title, null, !asTab && /*#__PURE__*/React.createElement(CreditCard, {
    mr: 2
  }), " ", CreditCardLabel), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaymentTable, {
    showAll: asTab,
    "data-testid": "creditCard-table",
    showMoreLabel: showMoreLabel,
    installments: creditCard.installmentPlans
  }))), pix && /*#__PURE__*/React.createElement(Item, _extends({}, itemProps, {
    "data-testid": "pix-panel",
    value: pix == null ? void 0 : pix.id
  }), /*#__PURE__*/React.createElement(Title, null, !asTab && /*#__PURE__*/React.createElement(PixIcon, {
    mr: 2
  }), " ", PixLabel), /*#__PURE__*/React.createElement(SlipContent, null, /*#__PURE__*/React.createElement(Amount, null, currencyFormatter({
    value: pix == null ? void 0 : (_pix$installmentPlans = pix.installmentPlans) == null ? void 0 : (_pix$installmentPlans2 = _pix$installmentPlans[0]) == null ? void 0 : _pix$installmentPlans2.installmentAmount
  })), !!Number(pix == null ? void 0 : (_pix$installmentPlans3 = pix.installmentPlans) == null ? void 0 : (_pix$installmentPlans4 = _pix$installmentPlans3[0]) == null ? void 0 : _pix$installmentPlans4.discount) && /*#__PURE__*/React.createElement(Discount, {
    as: "span"
  }, Number(pix == null ? void 0 : (_pix$installmentPlans5 = pix.installmentPlans) == null ? void 0 : (_pix$installmentPlans6 = _pix$installmentPlans5[0]) == null ? void 0 : _pix$installmentPlans6.discount), DiscountLabel), /*#__PURE__*/React.createElement(Description, {
    fontSize: 0
  }, PixDescription))), bankSlip && /*#__PURE__*/React.createElement(Item, _extends({}, itemProps, {
    "data-testid": "bankSlip-panel",
    value: bankSlip == null ? void 0 : bankSlip.id
  }), /*#__PURE__*/React.createElement(Title, null, !asTab && /*#__PURE__*/React.createElement(BankSlipIcon, {
    mr: 2
  }), " ", BankSlipLabel), /*#__PURE__*/React.createElement(SlipContent, null, /*#__PURE__*/React.createElement(Amount, null, currencyFormatter({
    value: bankSlip == null ? void 0 : (_bankSlip$installment = bankSlip.installmentPlans) == null ? void 0 : (_bankSlip$installment2 = _bankSlip$installment[0]) == null ? void 0 : _bankSlip$installment2.installmentAmount
  })), !!Number(bankSlip == null ? void 0 : (_bankSlip$installment3 = bankSlip.installmentPlans) == null ? void 0 : (_bankSlip$installment4 = _bankSlip$installment3[0]) == null ? void 0 : _bankSlip$installment4.discount) && /*#__PURE__*/React.createElement(Discount, {
    as: "span"
  }, Number(bankSlip == null ? void 0 : (_bankSlip$installment5 = bankSlip.installmentPlans) == null ? void 0 : (_bankSlip$installment6 = _bankSlip$installment5[0]) == null ? void 0 : _bankSlip$installment6.discount), DiscountLabel), /*#__PURE__*/React.createElement(Description, {
    fontSize: 0
  }, SlipDescription)))));
};

PaymentMethods.defaultProps = {
  asTab: true,
  showMoreLabel: 'veja mais',
  onChange: () => ({}),
  payments: {}
};
process.env.NODE_ENV !== "production" ? PaymentMethods.propTypes = {
  asTab: bool,
  showMoreLabel: string,
  payments: shape({
    luizaCard: shape({
      id: string,
      installmentPlans: arrayOf(shape({
        installment: number,
        installmentAmount: string,
        interestAmount: string,
        totalAmount: string
      }))
    }),
    creditCard: shape({
      id: string,
      installmentPlans: arrayOf(shape({
        installment: number,
        installmentAmount: string,
        interestAmount: string,
        totalAmount: string
      }))
    }),
    bankSlip: shape({
      id: string,
      discount: string,
      installmentAmount: string,
      interestAmount: string
    })
  }).isRequired,
  onChange: func
} : void 0;
export default PaymentMethods;